import React, {useState} from "react";
import {Button} from "@/components";
import {
    Sheet,
    SheetContent,
    SheetHeader,
    SheetTitle,
    SheetTrigger,
    SheetDescription,
} from "@/components/ui/sheet";
import ChannelForm from "./ChannelForm";
import {MdOutlineBlock} from "react-icons/md";
import {BiSolidEditAlt} from "react-icons/bi";
import {
    TooltipProvider,
    Tooltip,
    TooltipTrigger,
    TooltipContent,
} from "@/components/ui/tooltip";

const IntegratedChannel = ({
                               integratedChannels,
                               onRemoveChannel,
                               onUpdateChannel,
                               onIntegrate,
                               AlertDialog,
                           }) => {
    const [openStates, setOpenStates] = useState({});

    const handleOpenChange = (channelId, isOpen) => {
        setOpenStates(prev => ({
            ...prev,
            [channelId]: isOpen
        }));
    };
    if (integratedChannels.length === 0) return null;

    return (
        <TooltipProvider delayDuration={0}>
            <div className="flex flex-col gap-4 mt-5">
                <h2 className="md:text-headline3 text-headline4 font-nunito text-secondary-90 font-semibold">
                    Integrated Channels
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 w-full">
                    {integratedChannels?.map((channel) => {
                        const isOpen = openStates[channel.id] || false;
                        return (
                            <div
                                key={channel.id}
                                className="flex flex-col z-10 gap-4 bg-background_2 rounded-xl drop-shadow-sm p-6 items-center"
                            >
                                {channel.icon ? (
                                    <div className="flex-1 flex items-center justify-center">
                                        <img src={channel.icon} alt={channel.name.toLowerCase()}/>
                                    </div>
                                ) : (
                                    <div className="flex-1 flex items-center justify-center">
                                        <h2 className="md:text-headline2 text-headline4 text-secondary/95 font-bold font-nunito">
                                            {channel.name}
                                        </h2>
                                    </div>
                                )}
                                {channel.name === "WooCommerce" && (
                                    <div
                                        className="flex-1 flex items-center w-full overflow-hidden justify-center relative">
                                        <Tooltip>
                                            <TooltipTrigger asChild>
                        <span
                            className="truncate cursor-pointer font-nunito text-body2 text-secondary/90 font-semibold">
                          {channel.storeName}
                        </span>
                                            </TooltipTrigger>
                                            <TooltipContent
                                                side="top"
                                                align="center"
                                                className="px-2 py-1 max-w-56 z-[101] bg-black/90 font-nunito text-background rounded-md border-2 border-background/20 will-change-transform"
                                            >
                                                {channel.storeName}
                                            </TooltipContent>
                                        </Tooltip>
                                    </div>
                                )}
                                {
                                    channel.name === "Shopify" && (
                                        <div
                                            className="flex-1 flex items-center w-full overflow-hidden justify-center relative">
                                            <Tooltip>
                                                <TooltipTrigger asChild>
                        <span
                            className="truncate cursor-pointer font-nunito text-body2 text-secondary/90 font-semibold">
                            {channel.storeName.replace('.myshopify.com','') || "Shopify Store"}
                        </span>
                                                </TooltipTrigger>
                                                <TooltipContent
                                                    side="top"
                                                    align="center"
                                                    className="px-2 py-1 max-w-56 z-[101] bg-black/90 font-nunito text-background rounded-md border-2 border-background/20 will-change-transform"
                                                >
                                                    {channel.storeName}
                                                </TooltipContent>
                                            </Tooltip>
                                        </div>
                                    )
                                }
                                <div className="flex gap-2">
                                    <Sheet open={isOpen} onOpenChange={(open) => handleOpenChange(channel.id, open)}>
                                        <SheetTrigger asChild>
                                            <Button
                                                variant="outline"
                                                size="sm"
                                                disabled={!channel.isServiceable}
                                                className={
                                                    !channel.isServiceable
                                                        ? "!bg-rose-800/10 text-rose-700 hover:bg-gray-300 cursor-not-allowed border border-rose-300"
                                                        : ""
                                                }
                                                icon={
                                                    !channel.isServiceable
                                                        ? MdOutlineBlock
                                                        : BiSolidEditAlt
                                                }
                                                iconClassName="opacity-95"
                                            >
                                                {channel.isServiceable ? "Manage" : "Out of Service"}
                                            </Button>
                                        </SheetTrigger>
                                        {channel.isServiceable && (
                                            <SheetContent>
                                                <SheetHeader>
                                                    <SheetTitle>Manage {channel.name}</SheetTitle>
                                                    <SheetDescription></SheetDescription>
                                                </SheetHeader>
                                                <ChannelForm
                                                    channelId={channel.id}
                                                    formFields={channel.formFields}
                                                    onConnect={(channelId, data) =>
                                                        onIntegrate(channelId, data)
                                                    }
                                                    isUpdate={true}
                                                    AlertDialog={AlertDialog}
                                                    setOpen={(open) => handleOpenChange(channel.id, open)}
                                                />
                                            </SheetContent>
                                        )}
                                    </Sheet>
                                    <Button
                                        variant="ghost"
                                        size="sm"
                                        onClick={() => onRemoveChannel(channel.id)}
                                        className="!text-rose-700/90 hover:!bg-rose-300/20"
                                    >
                                        Remove
                                    </Button>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </TooltipProvider>
    );
};

export default IntegratedChannel;
